module.exports = __webpack_public_path__ + "img/ceramic.13a3a823.png";